import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(public)/freelancer/Landing.tsx");
